module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "prices-menu"
    }
  }, [_c('md-tabs', {
    attrs: {
      "md-active-tab": _vm.activeTab
    }
  }, [_c('md-tab', {
    attrs: {
      "id": "tab-prices",
      "to": {
        name: 'Prices'
      },
      "md-label": "Список"
    }
  }), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "tab-settings",
      "to": {
        name: 'PricesSettings'
      },
      "md-label": "Настройки"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-190a99a6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/PricesMenu.vue
// module id = 1048
// module chunks = 0